module.exports = __webpack_public_path__ + "static/img/アセット 79@3x.0180c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 79@3x.png
// module id = yie7
// module chunks = 1